export enum LoiFormAnswerType {
    String = 0,
    Number = 1,
    Date = 2,
    PurchaseAgreementType = 3,
    LeaseRateUponExtension = 4,
}

export interface LoiFormAnswerTypeOption {
    value: string;
    label: string;
}

export const LoiFormAnswerTypeList: Array<{
    id: LoiFormAnswerType;
    name: string;
    options?: LoiFormAnswerTypeOption[];
    isImplemented?: boolean;
}> = [
    { id: LoiFormAnswerType.String, name: 'String' },
    { id: LoiFormAnswerType.Number, name: 'Number' },
    { id: LoiFormAnswerType.Date, name: 'Date', isImplemented: false },
    {
        id: LoiFormAnswerType.PurchaseAgreementType,
        name: 'Purchase Agreement Type',
        options: [
            { value: 'Assets', label: 'Assets' },
            { value: 'Equity', label: 'Equity' },
        ],
    },
    {
        id: LoiFormAnswerType.LeaseRateUponExtension,
        name: 'Lease Rate Upon Extension',
        options: [
            { value: 'FMV Reset', label: 'FMV Reset' },
            { value: 'Annual Escalation %', label: 'Annual Escalation %' },
        ],
    },
];

export function getOptionsForAnswerType(
    answerType: LoiFormAnswerType
): LoiFormAnswerTypeOption[] {
    const entry = LoiFormAnswerTypeList.find((e) => e.id === answerType);
    return entry?.options ?? [];
}

export const REAL_PROPERTY_OPTIONS = [{ value: 'Yes', label: 'Yes' }, { value: 'No', label: 'No' }] as const;